import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoilerroomWarning = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8.5,
		cy: 8,
		r: 7.5,
		stroke: "#D0D0D0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.95 4.53L8.84 9.53H8.08L7.97 4.53H8.95ZM8.5 11.56C8.32667 11.56 8.18 11.5 8.06 11.38C7.94 11.26 7.88 11.1133 7.88 10.94C7.88 10.7667 7.94 10.62 8.06 10.5C8.18 10.38 8.32667 10.32 8.5 10.32C8.66667 10.32 8.80667 10.38 8.92 10.5C9.04 10.62 9.1 10.7667 9.1 10.94C9.1 11.1133 9.04 11.26 8.92 11.38C8.80667 11.5 8.66667 11.56 8.5 11.56Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgBoilerroomWarning);
export default ForwardRef;
